import { useEffect } from "react";
import { EU_GTM_ID, GLOBAL_GTM_ID } from "@/configs/gtmConstant";
import { usePageURL } from "@/shared/customHooks";
import TagManager from "react-gtm-module";

const GTMContainer = () => {
  const { countryCode } = usePageURL();
  useEffect(() => {
    let gtmId = "";
    const isEuBd = ["de", "at", "ch", "hu", "pl"].includes(countryCode);
    if (isEuBd) {
      gtmId = EU_GTM_ID;
    } else {
      gtmId = GLOBAL_GTM_ID;
    }

    if (gtmId) {
      TagManager.initialize({ gtmId });
    }
  }, [countryCode]);
  return null;
};

export default GTMContainer;
